export default {
  LOAD_MY_HOURS_LIST_PAGE_START: 'LoadMyGeneralCompetencyHoursListPageStart',
  LOAD_MY_HOURS_LIST_PAGE_END: 'LoadMyGeneralCompetencyHoursListPageEnd',
  SORT_MY_HOURS_LIST: 'SortMyGeneralCompetencyHoursList',
  TOGGLE_ENTER_CODE_DIALOG: 'ToggleMyGeneralCompetencyHoursEnterCodeDialog',
  SUBMIT_CODE_START: 'SubmitMyGeneralCompetencyHoursCodeStart',
  SUBMIT_CODE_END: 'SubmitMyGeneralCompetencyHoursCodeEnd'
};
